export default "__VITE_ASSET__57ed172f__"